module.exports = __webpack_public_path__ + "static/media/19ESCAP17.4902e2d9.jpg";